module.exports = __webpack_public_path__ + "img/codeBox.49a04ff4.png";